import "./reactive-element-CzWTglSF.js";
import { query as y } from "../beacon-query.d/index.js";
import { queryAll as b } from "../beacon-query-all.d/index.js";
const f = ({
  finisher: e,
  descriptor: n
}) => (t, u) => {
  var r;
  if (u !== void 0) {
    const a = t.constructor;
    n !== void 0 && Object.defineProperty(t, u, n(u)), e == null || e(a, u);
  } else {
    const a = (r = t.originalKey) != null ? r : t.key, l = n !== void 0 ? {
      kind: "method",
      placement: "prototype",
      key: a,
      descriptor: n(t.key)
    } : { ...t, key: a };
    return e && (l.finisher = function(s) {
      e(s, a);
    }), l;
  }
};
function i(e, n, t = {}, u = !1) {
  var l;
  const r = `slot${n ? `[name=${n}]` : ":not([name])"}`, a = (l = e.renderRoot) == null ? void 0 : l.querySelector(r);
  return a ? u ? a.assignedNodes(t).filter((s) => s.nodeType !== Node.COMMENT_NODE) : a.assignedElements(t) : [];
}
function g(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? {
    alternateSlot: e.alternateSlot,
    version: e.version
  } : {
    alternateAttribute: e.alternateAttribute,
    version: e.version
  };
}
function v(e, n = !1) {
  const { slot: t, selector: u, deprecated: r, flatten: a } = e != null ? e : {};
  let l;
  return r && (l = g(r)), f({
    descriptor: (s) => ({
      get() {
        let o = i(this, t, { flatten: a });
        return o.length === 0 && r && l && l.alternateSlot && (o = i(this, l.alternateSlot, {
          flatten: a
        })), u ? o == null ? void 0 : o.filter((c) => {
          var m;
          return n ? ((m = c == null ? void 0 : c.nodeName) == null ? void 0 : m.toLowerCase()) === this.getScopedTagName(u) : c.matches(u);
        }) : o;
      },
      set() {
        if (r) {
          const o = t != null ? t : "";
          this.alternateSlots.set(o, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function N(e) {
  return function(n, t) {
    return y(e)(n, t);
  };
}
function q(e, n) {
  return f({
    descriptor: (t) => ({
      get() {
        var r;
        return (r = this.querySelector(e)) != null ? r : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function A({ slot: e, defaultValue: n }) {
  return f({
    descriptor: (t) => ({
      get() {
        var a, l, s;
        const r = i(this, e)[0];
        return (s = (l = (a = r == null ? void 0 : r.textContent) == null ? void 0 : a.trim()) != null ? l : n) != null ? s : "";
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function C(e) {
  return function(n, t) {
    return b(e)(n, t);
  };
}
function E(e) {
  const { slot: n, deprecated: t, flatten: u } = e != null ? e : {};
  let r;
  return t && (r = g(t)), f({
    descriptor: (a) => ({
      get() {
        let l = i(this, n, { flatten: u }, !0);
        return l.length === 0 && t && r && r.alternateSlot && (l = i(
          this,
          r.alternateSlot,
          { flatten: u },
          !0
        )), l;
      },
      set() {
        if (t) {
          const l = n != null ? n : "";
          this.alternateSlots.set(l, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  v as a,
  N as b,
  C as c,
  E as d,
  q,
  A as s
};
